import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './box-wrapper.css';

const BoxWrapper = (props) => {
    const { children } = props;

    return (
        <section className={styles.wrapper}>
            {children}
        </section>
    );
};

BoxWrapper.propTypes = {
    children: PropTypes.node
};

export default BoxWrapper;
